import React from "react";
import file from '../../../../Global/assets/SOILPHFINAL.mp4'

const SoilPH = () => {
    return (
        <>
            <div id="ExperimentsB" style={{ height: '110vh' }}>
                <div style={{ width: '80%', height: '50%' }}>
                    <video src={file} width='100%' height='100%' controls></video>
                </div>
                <div style={{width:'80%', height:'30vh', color:'#fff'}}>
                    <h1>pH of Soil.</h1><br />
                    <h6>Observations : </h6><br />
                    <h6>1. The colour of the pH Strip stays Yellow.</h6>
                    <h6>2. pH of the Soil : Between 4-5</h6>
                    <h6>.3. We can conclude that the soil is slightely acidic.</h6>
                    <h6>4. The Soil is acidic as the pH is lower than 7.</h6>
                </div>
            </div>
        </>
    )
}

export { SoilPH }